import type { ARTICLES_LIST_DATA, ARTICLES_LIST_PARAMS, ARTICLES_LIST_PARAMS_DEVICE } from './types'

import { DEFAULT_PADDING, DEFAULT_WIDTH } from '../../const'

const DEFAULT_ARTICLES_LIST_PARAMS_DEVICE = (): ARTICLES_LIST_PARAMS_DEVICE => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  padding: DEFAULT_PADDING(),
  loadMore: true,
})

export const DEFAULT_ARTICLES_LIST_PARAMS = (): ARTICLES_LIST_PARAMS => ({
  pc: DEFAULT_ARTICLES_LIST_PARAMS_DEVICE(),
  tablet: DEFAULT_ARTICLES_LIST_PARAMS_DEVICE(),
  mobile: DEFAULT_ARTICLES_LIST_PARAMS_DEVICE(),
})

export const DEFAULT_ARTICLES_LIST_DATA = (): ARTICLES_LIST_DATA => ({
  id: null,
  classes: null,
  styles: null,
  count: 6,
  sections: [],
  type: 'articles-list',
})
